import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface CommonCustomContainerStyles {
    container?: InjectableCss;
}

export const CommonCustomContainerStyles: CommonCustomContainerStyles = {
    container: {
        css: css`
            border: #e1e1e1 1px solid;
            background: #fafafa;
            padding: 10px;
            > div[class^="Wrapper"] {
                .div-button {
                    .btn-contact-us {
                        cursor: pointer;
                        font-family: inherit;
                        height: 40px;
                        line-height: 1;
                        -webkit-backface-visibility: hidden;
                        backface-visibility: hidden;
                        -webkit-transition: all 200ms ease-in-out;
                        transition: all 200ms ease-in-out;
                        padding: 0 21px;
                        border: 2px solid #275aa8;
                        background: #275aa8;
                        &:hover {
                            background: #fff;
                            span {
                                color: #275aa8;
                            }
                        }
                        a {
                            outline: none;
                        }
                        span {
                            font-size: 15px;
                            font-weight: bold;
                            color: #fff;
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        height: 50px;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
                .is-draggable {
                    background-image: url(/UserFiles/Images/staticpages/cooney-bldg-2020.jpg);
                    background-size: cover;
                    background-position: center center;
                    p {
                        font-size: 16px;
                        font-weight: 500;
                        text-shadow: 0 2px 7px #000;
                        line-height: 25px;
                    }
                }
            }
            a {
                u {
                    color: #ef3742;
                    &:hover {
                        color: #c2185b;
                    }
                }
            }
            div[class^="ContentWrapper"] {
                > .min-height {
                    // min-height: 390px;
                    padding: 20px 30px;
                    position: relative;
                    border: 1px solid #e4e4ed;
                    // box-shadow: 0 2px 4px #e4e4ed;
                    margin: 10px;
                    //display: flex;
                    flex-direction: column;
                    background-color: #fff;
                    > .heading-and-brand {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        display: block;
                                    `,
                                ],
                                "max",
                            )}
                    }
                    >p: last-child {
                        margin-bottom: 0;
                    }
                    a {
                        u {
                            color: #ef3742;
                            &:hover {
                                color: #c2185b;
                            }
                        }
                    }
                }
                > p {
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                a {
                    u {
                        color: #ef3742;
                        &:hover {
                            color: #c2185b;
                        }
                    }
                }
            }
            div[data-test-selector="brandLogo"] {
                max-width: 300px;
                width: 100%;
                margin: 0 auto;
            }
            div[data-test-selector="brandImage"] {
                div[class^="GridOffset"] {
                    max-width: 100%;
                }
                div[class^="GridItemStyle"] {
                    justify-content: flex-end;
                    h3 {
                        display: none;
                    }
                    [class^="GridWrapper"] {
                        padding: 0;
                    }
                }
            }
            div[data-test-selector="brandProductLines"] {
                h3 {
                    margin-bottom: 10px;
                }
            }
        `,
    },
};

const styles = CommonCustomContainerStyles;

const CommonCustomContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="CommonCustomWrapper">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CommonCustomContainer,
    definition: {
        displayName: "Common Custom Container",
        group: "Common",
    },
};

export default widgetModule;
